import { Outlet, createFileRoute } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

/** Names the shelf between the library and one template: Library > Plany > Template. */
export const Route = createFileRoute("/(private)/library/plans")({
  loader: () => ({ crumb: m.library_tab_plans() }),
  component: Outlet,
});
